export const MODULE_NAME = 'consents'
